export default __webpack_public_path__ + "static/media/insecure-480w.52e6e74d.png";